/**
 * Creates a modal with filterable list of items to select.
 * @requires Bootstrap-vue.js for UI components
 *
 * @param item-factory: function to create the item values.
 * @param item-display: function to format the item values. Input is the item or item object.
 * @param item-selected: function to execute when item is selected. Input is the item or item object selected.
 *
 * @example: <form-filterlist v-bind:item-factory="getCurrencyItems" v-bind:item-display="displayCurrencyItem" v-bind:item-selected="selectCurrencyItem"></form-filterlist>
 */
<template>

  	<b-modal v-model="itemsVisible" ok-only>
  	  <b-container>
  	  	<b-row v-if="header">
  	  		<h3 class="mx-auto">{{ header }}</h3>
  	  	</b-row>
	    <b-row >
	    <b-form-input type="text" placeholder="Filter items" ref="filterText" v-model="matchTerm" v-on:input="matchItems()"></b-form-input>
		</b-row>
    	<b-row v-for="item in itemList" >
    		<b-col @click="selectItem(item)" v-bind:class="getItemStyle(item)"><span v-html="displayItemHtml(item)"></span>{{ displayItem(item) }}</b-col>
    	</b-row>
      </b-container>
    </b-modal>

</template>


<style scoped>
</style>


<script>

export default {
  props:{
	  'items': {type: Array, default: function() { return [] }},
	  'target': {type: String},
	  'header': {type: String},
	  'itemFactory': {type: Function},
	  'itemSelected': {type: Function},
	  'itemDisplay': {type: Function},
	  'itemStyle': {type: Function},
	  'itemHtml': {type: Function},
	  'refreshItems': {type: Boolean, default: function() {return false; }},  // refresh item list on each display
	  'hideOnSelect': {type: Boolean, default: function() {return false; }},  // hide modal when item is selected
  },
  data () {
    return {
    	itemList:[],
    	targetRef: null, // holds reference to target field
    	lastMatch: null,
    	itemsVisible: false,
    	matchTerm: null,
    }
  },
  mounted: function(){

//	  if (typeof this.itemFactory === 'function') {
//
//		  var newItems = this.itemFactory();
//		  for (var itemCount = 0; itemCount < newItems.length; itemCount++) {
//			  this.$set(this.items, this.items.length, newItems[itemCount]);
//		  }
//	  }

  },
  methods: {
	  selectItem(item) {
		  // set target field equal to selected value
		  if (typeof this.itemSelected === 'function') {
			  this.itemSelected(item);
		  }

		  if (this.hideOnSelect === true) {
			  this.itemsVisible = false;
		  }
	  },

	  displayItem(item) {

		  if (item) {

			  if (typeof this.itemDisplay === 'function') {
				  // run custom function
				  return this.itemDisplay(item);
			  }
			  else if (typeof item == 'object') {
				  // look for a .label property first
				  if (item.label) {
					  return item.label;
				  }
				  // look for an .name property
				  else if (item.name) {
					  return item.name;
				  }
				  // look for an .id property
				  else if (item.id) {
					  return item.id;
				  }
			  } else {
				  // expecting a string
				  return item;
			  }
		  }

		  return null;
	  },

	  displayItemHtml(item) {
		  // Return custom HTML for this item

		  if (item) {

			  if (typeof this.itemHtml === 'function') {
				  // run custom function
				  return this.itemHtml(item);
			  }
		  }

		  return null;
	  },

	  getItemStyle(item) {
		  // Run custom function to return item class
		  if (typeof this.itemStyle === 'function') {
			  return this.itemStyle(item);
		  } else {
			  return null;
		  }
	  },

	  showItems(match) {

		  this.getItems(); // load items if needed

		  if (match) {
			  this.matchTerm = match;
		  }
		  this.itemsVisible = true;
		  this.matchItems();
	  },

	  getItems() {

		  if ((this.items.length == 0) || (this.refreshItems === true)) {

			  if (typeof this.itemFactory === 'function') {

				  this.items.splice(0); // clear previous list

				  var newItems = this.itemFactory();
				  for (var itemCount = 0; itemCount < newItems.length; itemCount++) {
					  //this.$set(this.items, this.items.length, newItems[itemCount]);
					  this.items.push(newItems[itemCount]);
				  }
			  }
		  }

		  return this.items;
	  },

	  matchItems() {

		  var itemInfo;
		  var matchRe;

		  // if target reference exists
		  if (true) {

			  // clear previous matches
			  this.itemList.splice(0);

			  if (this.matchTerm) {
				  matchRe = new RegExp(this.matchTerm, 'i');
			  }

			  for (var itemCount = 0; itemCount < this.items.length; itemCount++) {

				  // build string of record data to match against
				  if (typeof this.items[itemCount] == 'object') {
					  // match on object values
					  itemInfo = Object.values(this.items[itemCount]).join(" ");
				  } else {
					  itemInfo = this.items[itemCount].toString();
				  }


				  if ((this.matchTerm) && (matchRe)) {

					  if (itemInfo.match(matchRe)) {
						  // add new value if it matches
						  this.$set(this.itemList, this.itemList.length, this.items[itemCount]);
					  }

				  } else {
					  // add all items if no match terms
					  this.$set(this.itemList, this.itemList.length, this.items[itemCount]);

				  }
			  }


		  }

		  return this.itemList;

	  }

  }
}
</script>




// WEBPACK FOOTER //
// src/components/FormFilterlist.vue